import axios from 'axios';
import { HOTEL_ID, TOKEN } from '../constants';
//  axio header setup
axios.defaults.baseURL =
    process.env.REACT_APP_NODE_ENV === 'production'
        ? process.env.REACT_APP_PROD_BASE_URL
        : process.env.REACT_APP_DEV_BASE_URL;

axios.defaults.headers.common['Accept'] = 'application/json, text/plain, */*';
axios.defaults.headers.post['Content-Type'] = 'application/json';

export const getToken = () => {
    try {
        const res = localStorage.getItem(TOKEN);
        return res;
    } catch (error) {}
};

axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';
// Add a request interceptor
axios.interceptors.request.use(
    function (config) {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        const { response } = error;
        const { request, ...errorObject } = response;
        if (errorObject.status === 401) {
            // window.location.replace('/');
        }

        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    }
);
export const getRestaurantDetails = (ID) => {
    return axios.get(`api/v5.0.1/restaurant/guest/restaurant_properties/${ID}`);
};
export const getHotelDetails = (ID) => {
    return axios.get(`api/v5.0.1/guest/hotel/details/${ID}`);
};
export const getMenusOnly = (ID) => {
    const langCode = localStorage.getItem('lang') || 'en';
    return axios.get(`api/v5.0.1/restaurant/guest/menus-only/${ID}?lang_code=${langCode}`);
};
export const getVerifyRoomNo = (table, isV5URL = false) => {
    const hotelID = localStorage.getItem(HOTEL_ID) || false;
    return axios.get(`/api/v5.0.1/guest/restaurant/table_no/verify/${hotelID}/${table}`);
};
export const placeOrder = (payload) => {
    return axios.post(`/api/v5.0.1/restaurant/guest/order`, payload);
};
export const registeGuest = (id) => {
    const payload = {
        hotel_enc_id: id,
        email: '',
        device_type: 'web',
        device_token:
            'fnESmSF3Syk:APA91bFsHoiBpxwRcjcBzE4q3FEUWg0HS2gbu8BkjUm2JaLG3e6Fnonr1yV-BTZI9RiOovhQr4G7JszhQ8dx1lxrxCelY_rSNjizzAYnURW6BNj44UAQlDzGzz6ZrLzz6PB_oxg67lSn',
    };
    return axios.post(`/api/v5.0.1/register-guest`, payload);
};
